var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{style:({ background: _vm.$vuetify.theme.themes[_vm.theme].background }),attrs:{"id":"app"}},[(_vm.devModeBanner)?_c('DevModeBanner'):_vm._e(),_c('div',{class:{
      bg: !_vm.isTreeView
    }}),_c('div',{class:{ bg: _vm.isTreeView, tree: _vm.isTreeView }},[_c(this.$route.meta.layout || 'div',{tag:"component"},[_c('router-view')],1)],1),_c('Confirm',{ref:"confirm"}),_c('Message',{ref:"message"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }